import { useCallback } from 'react';

import { Aptos, AptosConfig, Network } from '@aptos-labs/ts-sdk';
import { useWallet, type WalletName } from '@aptos-labs/wallet-adapter-react';

export function usePetraWallet() {
    const { connect, connected, account, signAndSubmitTransaction, signMessage, wallet } = useWallet();

    const handlePetraConnect = useCallback(async () => {
        if (!connected || !account) {
            connect(wallet?.name || ('Petra' as WalletName));
        }
        return account;
    }, [account, connect, connected, wallet?.name]);

    const handleTransaction = useCallback(
        async (transactionPayload) => {
            const aptosConfig = new AptosConfig({ network: Network.MAINNET });
            const aptos = new Aptos(aptosConfig);
            if (!connected) {
                await handlePetraConnect();
            }
            const response = await signAndSubmitTransaction({ ...transactionPayload });
            if (response) {
                const transactionRes = await aptos.waitForTransaction({ transactionHash: response.hash });
                if (transactionRes) {
                    return transactionRes;
                } else {
                    return false;
                }
            }
        },
        [connected, handlePetraConnect, signAndSubmitTransaction],
    );

    return { handlePetraConnect, handleTransaction, signMessage };
}
